<template>
  <div class="popup popup-goods">
  <header class="bar bar-nav close-popup">
    <div class="button button-link button-nav pull-left close-popup">
      <span class="icon icon-down"></span>
    </div>
    <h1 class='title'>
        <div v-if="$route.query.id" style="color: #c82829">
          <div v-if="$route.query.label">
            {{$route.query.label}}查询
          </div>
          <div v-else>促销查询</div>
        </div>
        <div v-else>搜索查询</div></h1>
    </header>

    <div class="bar bar-header-secondary">
      <div class="searchbar">
        <a class="searchbar-cancel close-popup">取消</a>
        <div class="search-input">
          <label class="icon icon-search" for="searchGoods"></label>
          <input type="search" id="searchGoods" placeholder='查询基因/病毒/功能...' v-model.trim="queryName"/>
        </div>
      </div>
    </div>

    <!--<div class="searchTr" style="margin-top: 15%" >-->
    <!--<div v-for="tag in tags" class="searchBox default">{{tag.tagLabel}}</div>-->
    <!--</div>-->

    <!--<div class="searchTr" style="margin-top: 4.5rem">-->
      <!--<div style="text-align: center">-->
        <!--<div class="searchBox default">细胞</div>-->
        <!--<div class="searchBox default">工具类腺病毒</div>-->
        <!--<div class="searchBox default">工具类AAV</div>-->
        <!--<div class="searchBox default">支原体相关试剂</div>-->
      <!--</div>-->

      <!--<div style="text-align: center">-->
        <!--<div class="searchBox default">基因工具</div>-->
        <!--<div class="searchBox default">文库</div>-->
        <!--<div class="searchBox default">上调</div>-->
        <!--<div class="searchBox default">下调</div>-->
      <!--</div>-->

    <!--</div>-->

    <div class="list-block" style="margin-top: 4.5rem;" v-if="showMatchData">
      <ul id="list">
        <li class="item-content close-popup" v-for="searchData in matchData">
          <div class="item-inner" @click="searchTarget(searchData, true)">
            <div id="results-goods" class="item-title close-popup">
              {{searchData.data.word}}
            </div>
            <div class="item-after">
              <span class="badge" v-for = "tag in searchData.tags">{{tag}}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div v-else  class="content infinite-scroll-top" data-distance="5"> <!--style="margin-top: 4rem"-->
      <div class="search_history" v-if="searchHistory.length&&searchHistory">
        <div class="list-block">
          <ul>
            <div class="blueTitle"></div>
            <div class="content-block-title" style="margin-top: 10px;margin-bottom: 10px;">搜索历史</div>
            <div class="content-block-title" style="margin-top: -1.2rem;margin-left: 86%;color:#f6383a" @click="removeSearchHistory">清空</div>
            <li class="item-content close-popup" v-for="(item, index) in searchHistory" v-if="!isRemoveSH">
              <div class="item-inner" @click="searchTarget(item, false)">
                <div class="item-title close-popup">
                 {{item.data.word}}
                </div>
                <div class="item-after">
                  <span class="badge" v-for="tag in item.tags">{{tag}}</span>
                </div>
              </div>
            </li>
            </ul>
        </div>
      </div>

      <div class="list-block" v-if = "hotWordList && hotWordList.length >0">
        <ul>
          <div class="blueTitle"></div>
          <div class="content-block-title" style="margin-top: 10px;margin-bottom: 10px;">热门搜索</div>
          <li class="item-content close-popup" v-for="item in hotWordList">
            <div class="item-inner" @click="searchTarget(item, false)">
              <div class="item-title close-popup">
                {{item.data.word}}
              </div>
              <div class="item-after" >
                <span class="badge" v-for="tag in item.tags">{{tag}}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import emkt from '../../emkt'
  import {mapMutations} from 'vuex'
  export default {
    mounted () {
      if (this.emkt.getLocalStorage('EmktSearchHistory')) {
        this.searchHistory = this.emkt.getLocalStorage('EmktSearchHistory')
      }
      var self = this
      $(function () {
        $('.popup .searchTr .searchBox').click(function () {
          $(this).toggleClass('selected')

          self.selectedTags = []
          let selectTags = $('.popup .searchTr')[0].getElementsByClassName('selected')
          for (let i = 0; i < selectTags.length; i++) {
            self.selectedTags.push(selectTags[i].innerHTML)
          }
          if (this.queryName !== '') {
            self.response()
          }
        })
        $('.close-popup').click(function () {
          self.queryName = ''
        })
      })
      this.fetchData()
    },
    created () {
    },
    data () {
      return {
        showMatchData: false,
        searchHistory: [],
        hotWords: [],
        data: [],
        matchData: [],
        searchValue: '',
        queryName: '',
        tags: [],
        selectedTags: [],
        keywordMeanings: [],
        param: {},
        isRemoveSH: false
      }
    },
    watch: {
      'queryName': 'response'
    },
    methods: {
      ...mapMutations([
        'ROUTER_STORE'
      ]),
      fetchData () {
        var self = this
        if (!this.emkt.getEmktMetaData()) {
          if (emkt.isDebug) {
            window.alert('EmktMetaData=' + this.emkt.getEmktMetaData())
          }
        }
        this.tags = this.emkt.getEmktMetaData().tags
        this.keywordMeanings = this.emkt.getEmktMetaData().keywordMeanings
        self.gcapi('getCustomerHotWords').then((response) => {
          self.hotWords = response.body.result
        })
        // console.log(`response: ${this.products}`)
//        this.data = JSON.parse(window.localStorage.getItem('enterpriseList'))
      },

      searchTarget (selectedItem, needCondition) {
        this.emkt.setStoreItem('isPopUpOpen', false)
        this.queryName = ''
        this.searchValue = selectedItem
        let allSelectedTagIds = []
        for (let h = 0; h < this.selectedTags.length; h++) {
          let item = this.emkt.getEmktMetaData().tagNamesMap[this.selectedTags[h]]
          item && allSelectedTagIds.push(item)
        }
        selectedItem.tagIds = allSelectedTagIds
        this.getHistoryData()
        if (this.$route.query && needCondition) {
          if (this.$route.query.des) {
            selectedItem.promotionGuid = this.$route.query.id
          } else {
            selectedItem.categoryId = this.$route.query.id
          }
        }
        if (!needCondition) {
          selectedItem.promotionGuid = undefined
          selectedItem.categoryId = undefined
        }
        if (this.$route.query.filterName && this.$route.query.filterName === 'promotionGuid') {
          selectedItem.promotionGuid = this.$route.query.filterValue
        }
        this.ROUTER_STORE(this.$route)
        if (this.$route.name === 'searchresults') {
          this.$router.replace({
            name: 'searchresults',
            query: {search: JSON.stringify(selectedItem)}
          })
        } else {
          this.$router.push({
            name: 'searchresults',
            query: {search: JSON.stringify(selectedItem)}
          })
        }
      },
      getHistoryData () {
        /**
         * 点击搜索结果进入下一页面时进行判断是否已经有一样的历史记录
         * 如果没有则新增，如果有则不做重复储存，判断完成后进入下一页
         */
        let searchHistory = this.emkt.getLocalStorage('EmktSearchHistory') === undefined ? [] : this.emkt.getLocalStorage('EmktSearchHistory')
        if (searchHistory) {
          let checkrepeat = false
          searchHistory.forEach(item => {
            if (item.data.word === this.searchValue.data.word) {
              checkrepeat = true
            }
          })
          if (!checkrepeat) {
            if (searchHistory.length >= 5) {
              searchHistory.splice(0, 1)
            }
            searchHistory.push(this.searchValue)
          }
        } else if (this.searchValue && this.searchValue.data.word !== '') {
          if (searchHistory.length >= 5) {
            searchHistory.splice(0, 1)
          }
          searchHistory.push(this.searchValue)
        }
        this.emkt.setLocalStorage('EmktSearchHistory', searchHistory)
        this.searchHistory = this.emkt.getLocalStorage('EmktSearchHistory')
        this.isRemoveSH = false
      },
      response () {
//        if (this.data === undefined) {
//          return
//        }
//        var allKeyWords = this.data.keywords
//        var meanings = this.data.meanings
//
//        this.matchData = []
//        let promotionId
//        let categoryId
//        if (this.$route.query) {
//          if (this.$route.query.des) {
//            promotionId = this.$route.query.id
//          } else {
//            categoryId = this.$route.query.id
//          }
//        }
//        let allSelectedTagIds = []
//        for (let h = 0; h < this.selectedTags.length; h++) {
//          allSelectedTagIds.push(this.emkt.getEmktMetaData().tagNamesMap[this.selectedTags[h]])
//        }
//
//        let match = this.data.wordsToKeyWords[this.queryName.toLocaleLowerCase()]
//        if (match) {
//          let containsSameTag = true
//          if (promotionId !== undefined && (match.promotionIds === undefined || $.inArray(promotionId, match.promotionIds) < 0)) {
//            containsSameTag = false
//          }
//          if (categoryId !== undefined && (match.categoryIds === undefined || $.inArray(+categoryId, match.categoryIds) < 0)) {
//            containsSameTag = false
//          }
//          for (let j = 0; j < allSelectedTagIds.length; j++) {
//            if ($.inArray(allSelectedTagIds[j], match.tagIds) < 0) {
//              containsSameTag = false
//              break
//            }
//          }
//          if (containsSameTag === true) {
//            let tagNames = []
//            for (let k = 0; k < match.meaningIds.length; k++) {
//              tagNames.push(meanings[match.meaningIds[k]])
//            }
//            let item = {'data': match, 'tags': tagNames}
//            this.matchData.push(item)
//          }
//        }
//        for (let w = 0; w < allKeyWords.length; w++) {
//          let word = allKeyWords[w].word
//          let tagIds = allKeyWords[w].tagIds
//          let meaningIds = allKeyWords[w].meaningIds
//          let promotionIds = allKeyWords[w].promotionIds
//          let categoryIds = allKeyWords[w].categoryIds
//
//          if (match && word.toLocaleLowerCase() === match.word.toLocaleLowerCase()) {
//            continue
//          }
//          let containsSameTagId = true
//          if (promotionId !== undefined && (promotionIds === undefined || $.inArray(promotionId, promotionIds) < 0)) {
//            containsSameTagId = false
//          }
//          if (categoryId !== undefined && (categoryIds === undefined || $.inArray(+categoryId, categoryIds) < 0)) {
//            containsSameTagId = false
//          }
//          for (let j = 0; j < allSelectedTagIds.length; j++) {
//            if ($.inArray(allSelectedTagIds[j], tagIds) < 0) {
//              containsSameTagId = false
//              break
//            }
//          }
//          if (containsSameTagId === true && word.toLowerCase().match(this.queryName.toLocaleLowerCase())) {
//            let tagNames = []
//            for (let k = 0; k < meaningIds.length; k++) {
//              tagNames.push(meanings[meaningIds[k]])
//            }
//            if (this.matchData.length > 100) {
//              break
//            } else {
//              let item = {'data': allKeyWords[w], 'tags': tagNames}
//              this.matchData.push(item)
//            }
//          }
//        }
        if (this.queryName === undefined || this.queryName === '') {
          this.showMatchData = false
        } else {
          let promotionId
          let categoryId
          if (this.$route.query) {
            if (this.$route.query.des) {
              promotionId = this.$route.query.id
            } else {
              categoryId = this.$route.query.id
            }
          }
          let allSelectedTagIds = []
          for (let h = 0; h < this.selectedTags.length; h++) {
            let item = this.emkt.getEmktMetaData().tagNamesMap[this.selectedTags[h]]
            item && allSelectedTagIds.push(item)
          }

          if (this.queryName !== '') {
            let param = {}
            param.keywordChosen = this.queryName
            param.categoryId = categoryId
            param.promotionId = promotionId
            param.tagIds = allSelectedTagIds
            this.param = param
            emkt.throttle(this.getQueryResult, 500, this)
          }
          this.showMatchData = true
        }
      },
      getQueryResult: function () {
        // let self = this
        // this.matchData = []
        // this.gcapi('queryKeywords', this.param).then((res) => {
        //   let result = res.body.result
        //   if (result) {
        //     let match = result.keywords
        //     let meanings = this.keywordMeanings
        //     for (let i = 0; i < match.length; i++) {
        //       let tagNames = []
        //       for (let k = 0; k < match[i].meaningIds.length; k++) {
        //         tagNames.push(meanings[match[i].meaningIds[k]])
        //       }
        //       let item = {'data': match[i], 'tags': tagNames}
        //       self.matchData.push(item)
        //     }
        //   }
        // })
      },
      removeSearchHistory () {
        window.localStorage.removeItem('EmktSearchHistory')
        this.searchHistory = this.emkt.getLocalStorage('EmktSearchHistory')
        this.emkt.removeStoreItem('EmktSearchHistory')
        this.isRemoveSH = true
      }
    },
    computed: {
      // a computed getter
      hotWordList: function () {
        let hotWordList = []

        let meanings = this.keywordMeanings
        this.hotWords.forEach(function (hotWord) {
          let names = []
          hotWord.meaningIds.forEach(function (meaningId) {
            names.push(meanings[meaningId])
          })
          hotWordList.push({data: hotWord, tags: names})
        })
        return hotWordList
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .search_history {
    background-color: #fff;
    margin-bottom: 0.4rem;
  }

  .list-block {
    margin-top: 1rem;
  }

  .searchTr .searchBox.default {
    display: inline-block;
    text-decoration: none;
    color: #000000;
    font-size: .7rem;
    line-height: 1;
    background-color: #dddddd;
    padding: 0.5em;
    border-radius:0.2rem;
    text-align: center;
    margin-left: 2%;
    margin-top: 0.2rem;
  }
  .searchTr .searchBox.selected {
    display: inline-block;
    text-decoration: none;
    color: #dddddd;
    font-size: .7rem;
    line-height: 1;
    background-color: #0261b5;
    padding: 0.5em;
    border-radius:0.2rem;
    text-align: center;
    margin-left: 2%;
  }


  .searchSecondTr .searchSecondBox .default {
    display: inline-block;
    width: 20%;
    text-decoration: none;
    color: #000000;
    background-color: #ececec;
    padding: 0.5em;
    border-radius:30px;
    text-align: center;
    margin-left: 10%;
  }
  .searchSecondTr .searchSecondBox .selected {
    display: inline-block;
    width: 20%;
    text-decoration: none;
    color: #000000;
    background-color: #045aa5;
    padding: 0.5em;
    border-radius:30px;
    text-align: center;
    margin-left: 10%;
  }
  .borderBottom {
    border-bottom: 1px solid #dddddd;
  }
  .blueTitle {
    width: 4rem;
    border-bottom: 2px solid #00469A;
  }
  .badge {
    color:#0894ec;
    background: white;
    text-decoration: none;
    font-size: 0.6rem;
  }
  .list-block .item-title {
    font-weight: bold;
  }
  .showSec-enter-active {
    animation: showSec-in .5s;
  }
  .showSec-leave-active {
    animation: showSec-in .5s reverse;
  }
  @keyframes showSec-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }
</style>



// WEBPACK FOOTER //
// SearchBox.vue?517b6879